
import React from 'react';
import { User, Check } from 'lucide-react';
import { type Contact } from '../contacts/types';

interface ContactCardProps {
  contact: Contact;
  onSelect: (contact: Contact) => void;
}

const ContactCard: React.FC<ContactCardProps> = ({ contact, onSelect }) => {
  return (
    <div 
      onClick={() => onSelect(contact)}
      className="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-slate-100 rounded-md"
    >
      <div className="flex-shrink-0 h-8 w-8 rounded-full bg-givgo-light flex items-center justify-center">
        {contact.avatar ? (
          <img src={contact.avatar} alt={contact.name} className="h-8 w-8 rounded-full" />
        ) : (
          <User className="h-4 w-4 text-givgo-purple" />
        )}
      </div>
      <div className="flex-1 overflow-hidden">
        <p className="font-medium truncate">{contact.name}</p>
        <p className="text-xs text-muted-foreground truncate">{contact.email}</p>
      </div>
      <Check className="h-4 w-4 opacity-0 group-data-[selected]:opacity-100" />
    </div>
  );
};

export default ContactCard;
